import React                        from 'react';
import PropTypes                    from 'prop-types';
import moment                       from 'moment';
import Paper                        from '~/components/Paper';
import { useTranslation }           from 'react-i18next';
import useStyles                    from './styles';
import MyLocation                   from '@material-ui/icons/MyLocation';
import List                         from '@material-ui/core/List';
import ListItem                     from '@material-ui/core/ListItem';
import Typography                   from '@material-ui/core/Typography';
import EventRecord                  from '~/records/EventRecord';

function EventStats({loading, record}) {
  const classes = useStyles();
  const { t } = useTranslation();

  const renderListItem = (text1, metric) => {
    return(
      <ListItem divider disableGutters >
        <Typography color='textSecondary'>{t(text1)}</Typography>
        <Typography className={classes.metric}>{metric} </Typography>
      </ListItem>
    );
  };
  return (
    <Paper
      Icon={MyLocation}
      title={t('event.extras.stats_title')}
      iconColor='orange'
      loading={loading}
    >
      <List>
        {renderListItem('event.attributes.distance', `${record.get('distance')>1000 ? `${String(record.get('distance')/1000).slice(0, -1)} km` : `${record.get('distance')} m`} `)}
        {renderListItem('event.extras.total_time', moment.duration(moment(record.get('end_date')).diff(moment(record.get('start_date')))).humanize())}
        {renderListItem('event.attributes.max_speed_reached', record.get('max_speed_reached') > 0 ? `${record.get('max_speed_reached')} km/h` : t('NA'))}
        {renderListItem('event.attributes.average_speed', record.get('average_speed') > 0 ? `${record.get('average_speed')} km/h` : t('NA'))}
        {renderListItem('event.extras.groups', `${record.get('event_teams') ? record.get('event_teams').length : 0}`)}
      </List>
    </Paper>
  );
}

EventStats.propTypes = {
  record: PropTypes.instanceOf(EventRecord).isRequired,
  loading: PropTypes.bool,
};

export default EventStats;
